/**
 * Botón de «Entrar con Google».
 *
 * QUIEN LO USA TIENE QUE HABER COMPROBADO ANTES que la autenticación está
 * disponible (`autenticacion_disponible: true` en `/api/perfil`). Este
 * componente no lo comprueba solo a propósito: si lo hiciera, pediría el perfil
 * otra vez desde cada sitio donde aparece y escondería la decisión de mostrarlo
 * o no, que es justo la que importa. Con la autenticación sin configurar,
 * pulsarlo devuelve 503 y aquí solo se podría enseñar el error después del
 * clic, cuando lo correcto es no ofrecer el botón.
 */

import { useState } from 'react'
import { entrarConGoogle } from '../api/autenticacion'
import { textoDeError } from '../api/errores'

interface PropiedadesBotonEntrar {
  /** Texto del botón. Cambia según dónde esté: encabezado o página bloqueada. */
  etiqueta?: string
}

export function BotonEntrar({
  etiqueta = 'Entrar con Google',
}: PropiedadesBotonEntrar) {
  const [entrando, setEntrando] = useState(false)
  const [fallo, setFallo] = useState<string | null>(null)

  async function alPulsar(): Promise<void> {
    setFallo(null)
    setEntrando(true)
    try {
      // Si funciona, la pestaña se va a Google y este componente desaparece;
      // por eso `setEntrando(false)` solo hace falta en la rama de error.
      await entrarConGoogle()
    } catch (error) {
      setFallo(textoDeError(error))
      setEntrando(false)
    }
  }

  return (
    <span className="entrar">
      <button
        type="button"
        className="boton"
        onClick={() => void alPulsar()}
        disabled={entrando}
      >
        {entrando ? 'Abriendo Google…' : etiqueta}
      </button>
      {fallo !== null && (
        <span className="entrar__fallo" role="alert">
          {fallo}
        </span>
      )}
    </span>
  )
}
